import loadable from '@loadable/component';
import { AlternateHrefLangLink } from 'bernie-http';
import { Localization } from 'bernie-l10n';
import { supportedLocales } from 'shared/config/supported-locales';
var HomeController = /** @class */function () {
  function HomeController() {
    this.pageId = 'page.affhub.home';
    this.path = '/home';
    this.legacyPath = '/:localeName/home';
    this.routeName = 'home';
    this.bundles = [];
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "home";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function () {
        return import(/* webpackChunkName: "home" */'./home.view');
      },
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./home.view");
        }
        return eval('require.resolve')("./home.view");
      }
    });
    this.exact = true;
  }
  HomeController.prototype.fetch = function () {
    return Promise.resolve({});
  };
  HomeController.prototype.fetchPageData = function (options) {
    var localization = new Localization(options.context.locale);
    var pageData = {
      title: localization.formatText('home.page.title'),
      seo: {
        canonical: "https://affiliates.expediagroup.com/home",
        additionalMeta: supportedLocales.map(function (lang) {
          return new AlternateHrefLangLink(lang.langCode, "https://affiliates.expediagroup.com/home");
        }),
        description: localization.formatText('home.page.description'),
        robots: '',
        clickstreamPageName: 'affiliates_hub_home',
        clickstreamPageNameDetailed: 'Affiliate Hub Home'
      }
    };
    return Promise.resolve(pageData);
  };
  return HomeController;
}();
export { HomeController };